import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  margin: auto;\n  background: url(\"", "\") no-repeat center center;\n  transition: all 300ms ease-in-out;\n  transform: ", ";\n\n  &:hover {\n    background: ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    margin-right: 20px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    margin-right: 10px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n\n  @media screen and (max-width: ", "px) {\n    margin-left: 20px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 148px;\n  height: 44px;\n  padding: 0 7px;\n  justify-content: space-between;\n\n  @media screen and (max-width: ", "px) {\n    width: 95%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import DownArrowSVG from '../assets/icons/down-arrow.svg';
import { Button } from '../Button';
import { Spinner } from '../Spinner';
import styled from '../utils/styling/styled-components';
import { DROPDOWN_BUTTON } from '../utils/testing/TestIDs';
/**
 * Dropdown button is composed of a button, a text label
 * and a chevron that rotates up or down depending on the state of the
 * button. It looks a little something like:
 *
 *    ----------------
 *   (   Core      ▼  )
 *    ----------------
 *
 */

var Container = styled(Button)(_templateObject(), function (props) {
  return props.theme.breakpoints.md;
});
var Text = styled.div(_templateObject2(), function (props) {
  return props.theme.breakpoints.md;
});
var DownArrow = styled.div(_templateObject3(), DownArrowSVG, function (props) {
  return props.isOpen ? 'rotate(180deg)' : 'rotate(0)';
}, function (props) {
  return props.theme.colors.ivoryLight;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.sm;
});

var DropdownButton = function DropdownButton(_ref) {
  var isOpen = _ref.isOpen,
      label = _ref.label,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": DROPDOWN_BUTTON,
    onPress: onClick,
    type: "light",
    className: className
  }, loading ? /*#__PURE__*/React.createElement(Spinner, {
    height: 20,
    width: 20
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, label), /*#__PURE__*/React.createElement(DownArrow, {
    isOpen: isOpen
  })));
};

export { DropdownButton };